
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicRoutesApi extends BaseModulePublicApi {
  basePath = 'routes';
};
